/**
 * Open the hall plan on a given place.
 *
 * Used from the exhibitor list and from the programme, which run in two
 * different shells: the zpcard SPA, where a router push is enough, and CMS pages
 * embedding the same components, where the map is a separate page and the target
 * has to be loaded.
 *
 * The query is passed through verbatim -- the map resolves stand numbers, stage
 * captions, programme stage names and exhibitor names itself, so no caller needs
 * to know which kind it holds.
 */
export default {
  methods: {
    /**
     * The event whose map to open.
     *
     * Not every route carries one: the exhibitor list and the programme are
     * reachable as "/exhibitors" and "/talks" without an event in the path, and
     * reading the path alone sent every link from there to the eventless
     * "/hallenplan". The shell remembers the event it last visited for exactly
     * this reason -- the bottom navigation is built on the same value.
     */
    floorplanEventShortName() {
      const fromRoute = this.$route && this.$route.params.shortName
      if (fromRoute) return fromRoute
      const observed = this.$storage && this.$storage.observed
      return (observed && observed.currentEventShortName) || ''
    },

    floorplanRoute(query) {
      const shortName = this.floorplanEventShortName()
      return shortName
        ? {name: 'Event Hallplan', params: {shortName}, query: {q: query}}
        : {name: 'Hallplan', query: {q: query}}
    },

    /** True when this shell has the map as a route of its own. */
    hasFloorplanRoute() {
      // On a CMS page the map is a page rather than a route, and asking the
      // router for it by name only earns a warning in the console.
      if (this.$WebApp || !this.$router) return false
      try {
        return this.$router.resolve(this.floorplanRoute('x')).route.matched.length > 0
      } catch (e) {
        return false
      }
    },

    openFloorplan(query) {
      if (!query) return
      if (this.hasFloorplanRoute()) {
        this.$router.push(this.floorplanRoute(query)).catch(() => {})
        return
      }
      // The server names the page; see hallplan_url_for() in cms_plugins.py.
      // Absent when the page belongs to no event, and then there is no map to
      // open -- better to stay put than to guess at an address.
      const page = window.VUE_APP_FLOORPLAN_URL
      if (!page) return
      window.location.href = `${page}?q=${encodeURIComponent(query)}`
    },
  },
}
